import { RequestService } from '../../../common/services/RequestService';
import { GET_MAINTENANCE_LEVELS } from '../constants';

export const getMaintenanceLevels = payload => {
  return RequestService.get(GET_MAINTENANCE_LEVELS);
};
